import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './MySummaries.css';

const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

const MySummaries = () => {
  const [summaries, setSummaries] = useState([]);
  const [filteredSummaries, setFilteredSummaries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchSummaries();
  }, []);

  const fetchSummaries = async () => {
    try {
      const response = await axios.get(`${API_URL}/summaries/my-summaries`);
      setSummaries(response.data.summaries);
      setFilteredSummaries(response.data.summaries);
    } catch (err) {
      console.error('Failed to fetch summaries:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredSummaries(summaries);
      return;
    }

    const query = searchQuery.toLowerCase().trim();
    const filtered = summaries.filter(summary => 
      summary.title?.toLowerCase().includes(query) ||
      summary.authors?.some(author => author.toLowerCase().includes(query)) ||
      summary.summary_text?.toLowerCase().includes(query)
    );

    setFilteredSummaries(filtered);
  }, [searchQuery, summaries]);

  const handleBookClick = (googleBooksId) => {
    navigate(`/book/${googleBooksId}`);
  };

  if (loading) {
    return <div className="loading">Loading summary...</div>;
  }

  return (
    <div className="container">
      <div className="page-header">
        <h1>Summary</h1>
        <p>All your AI-generated book summary</p>
      </div>

      {summaries.length > 0 && (
        <div className="search-container">
          <input
            type="text"
            placeholder="Search by book title, author, or summary text..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>
      )}

      {summaries.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📝</div>
          <h2>No summaries yet</h2>
          <p>Search for books and generate your first AI summary!</p>
        </div>
      ) : (
        <div className="summaries-list">
          {filteredSummaries.length === 0 ? (
            <div className="no-results">
              <p>No summaries found matching your search.</p>
            </div>
          ) : (
            filteredSummaries.map((summary) => (
            <div key={summary.id} className="summary-item">
              <div className="summary-item-header">
                <div
                  className="summary-book-info"
                  onClick={() => handleBookClick(summary.google_books_id)}
                >
                  {summary.image_url && (
                    <img src={summary.image_url} alt={summary.title} />
                  )}
                  <div>
                    <h3>{summary.title}</h3>
                    <p className="summary-authors">
                      {summary.authors?.join(', ') || 'Unknown Author'}
                    </p>
                  </div>
                </div>
                <div className="summary-rating-display">
                  {summary.average_rating > 0 && (
                    <span>
                      ⭐ {parseFloat(summary.average_rating).toFixed(1)} ({summary.ratings_count} ratings)
                    </span>
                  )}
                </div>
              </div>
              <div className="summary-item-content">
                <p className="summary-date">
                  Created: {new Date(summary.created_at).toLocaleDateString()}
                </p>
                <p className="summary-text">
                  {summary.summary_text.substring(0, 300)}
                  {summary.summary_text.length > 300 && '...'}
                </p>
                <button
                  onClick={() => handleBookClick(summary.google_books_id)}
                  className="btn btn-primary"
                >
                  View Full Summary
                </button>
              </div>
            </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default MySummaries;
